<template>
  <div>
    <h1>通知</h1>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
